/*
  "numberOfEmployees",
  "headquarters",
  "slogan",
  "contact",
  "socialMedia",
  "resources",
  "highlights",
  "newsworthy",
*/

export function hasMakersContent(values: any): boolean {
  if (values["numberOfEmployees"] !== null) {
    return true;
  }

  if (values["headquarters"]) {
    return true;
  }

  if (values["slogan"]) {
    return true;
  }

  if (
    values["socialMedia"] &&
    (values["socialMedia"]["facebook"] ||
      values["socialMedia"]["instagram"] ||
      values["socialMedia"]["linkedin"] ||
      values["socialMedia"]["twitter"] ||
      values["socialMedia"]["youtube"])
  ) {
    return true;
  }

  if (Array.isArray(values["resources"]) && values["resources"].length > 0) {
    return true;
  }

  if (Array.isArray(values["highlights"]) && values["highlights"].length > 0) {
    return true;
  }

  if (Array.isArray(values["newsworthy"]) && values["newsworthy"].length > 0) {
    return true;
  }

  return false;
}
